import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import FiltersState from './filters.state';

const initialState: TableFilters = { ...FiltersState };

export const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    SET_FILTERS: (state, action: PayloadAction<Partial<TableFilters>>) => {
      return { ...state, ...action.payload };
    },
  },
});

export default filtersSlice.reducer;
